import { buildApiUrl, withBusinessHeaders } from './apiConfig';

const RECEIVINGS_API_URL =
  process.env.REACT_APP_RECEIVINGS_API_URL || buildApiUrl('/receivings');

export async function fetchPendingPurchaseOrders() {
  const response = await requestReceivingApi(`${RECEIVINGS_API_URL}/pending-purchase-orders`, {
    fallbackMessage: 'Unable to load receiving purchase orders right now.',
  });

  return response.json();
}

export async function fetchReceivingPurchaseOrders() {
  const response = await requestReceivingApi(`${RECEIVINGS_API_URL}/purchase-orders`, {
    fallbackMessage: 'Unable to load receiving records right now.',
  });

  return response.json();
}

export async function fetchInventoryItems(options = {}) {
  const searchParams = new URLSearchParams();

  if (options.includeUnlocked) {
    searchParams.set('includeUnlocked', 'true');
  }

  const queryString = searchParams.toString();
  const response = await requestReceivingApi(
    `${RECEIVINGS_API_URL}/inventory${queryString ? `?${queryString}` : ''}`,
    {
    fallbackMessage: 'Unable to load inventory right now.',
    }
  );

  return response.json();
}

export async function createReceiving(payload) {
  const response = await requestReceivingApi(RECEIVINGS_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    fallbackMessage: 'Unable to submit receiving right now.',
  });

  return response.json();
}

export async function updateReceivingItem(id, payload) {
  const response = await requestReceivingApi(`${RECEIVINGS_API_URL}/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    fallbackMessage: 'Unable to update receiving item right now.',
  });

  return response.json();
}

export async function createReceivingItem(payload) {
  const response = await requestReceivingApi(`${RECEIVINGS_API_URL}/items`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    fallbackMessage: 'Unable to add receiving item right now.',
  });

  return response.json();
}

async function requestReceivingApi(url, options) {
  const { fallbackMessage, ...requestOptions } = options;
  let response;

  try {
    response = await fetch(url, {
      ...requestOptions,
      headers: withBusinessHeaders(requestOptions.headers),
    });
  } catch (error) {
    throw new Error(getNetworkErrorMessage(error, fallbackMessage));
  }

  if (!response.ok) {
    const errorPayload = await safeReadJson(response);
    throw new Error(errorPayload?.message || fallbackMessage);
  }

  return response;
}

function getNetworkErrorMessage(error, fallbackMessage) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return 'You are offline right now. Please reconnect to continue.';
  }

  if (error instanceof TypeError) {
    return 'Unable to reach the server right now. Please check your connection or try again in a moment.';
  }

  return fallbackMessage;
}

async function safeReadJson(response) {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}
